<span class="ui-alert__icon" aria-hidden="true">
  <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.99868 15.0019C11.8654 15.0019 15 11.8673 15 8.00063C15 4.13392 11.8654 0.999329 7.99868 0.999329C4.13197 0.999329 0.997375 4.13392 0.997375 8.00063C0.997375 11.8673 4.13197 15.0019 7.99868 15.0019Z" stroke="currentColor" stroke-width="1.2"/>
    <path d="M8.00171 11.8172V7.61646" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
    <path d="M8.10049 5.02515C8.10049 4.96985 8.05566 4.92502 8.00036 4.92502C7.94506 4.92502 7.90023 4.96985 7.90023 5.02515C7.90023 5.08045 7.94506 5.12528 8.00036 5.12528C8.05566 5.12528 8.10049 5.08045 8.10049 5.02515Z" fill="currentColor" stroke="currentColor" stroke-width="1.2"/>
  </svg>
</span>

<div class="ui-alert__body">
  @if (data().title) {
    <div class="ui-alert__title">{{ data().title }}</div>
  }
  @if (data().message) {
    <div class="ui-alert__message" [ui-markdown]="data().message ?? ''" [openLinksInNewTab]="data().openLinksInNewTab ?? false"></div>
  }
  @if (data().buttons?.length) {
    <div class="ui-alert__footer">
      @for (btn of data().buttons; track (btn.id || btn.text)) {
        <button
          type="button"
          [class.btn-primary]="btn.primary"
          [class.btn-outline]="!btn.primary"
          (click)="onButtonClick(btn, $event)"
        >{{ btn.text }}</button>
      }
    </div>
  }
</div>

<button type="button" class="ui-alert__close" aria-label="Close" (click)="close()">
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.9987 10.0007L3.33203 3.33398M9.9987 10.0007L16.6654 16.6673M9.9987 10.0007L16.6654 3.33398M9.9987 10.0007L3.33203 16.6673" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</button>
